import ParagraphAndCarouselReviewsComponent from "./paragraph-and-carousel-reviews-component";
import ParagraphAndCarouselReviewsConfig from "./paragraph-and-carousel-reviews-config";
import ParagraphAndCarouselReviewsAdvancedConfig from "./paragraph-and-carousel-reviews-advanced-config";

export default {
  ParagraphAndCarouselReviewsComponent,
  ParagraphAndCarouselReviewsConfig,
  ParagraphAndCarouselReviewsAdvancedConfig
};
